import { computed, type Ref } from 'vue'

import { SurveyResponsesViewEnum, useReviewsProductSurveyResponsesViewFacetQuery } from '@/gql/reviews'

export function useOutdatedReviewCount(slug: Ref<string>) {
  const variables = computed(() => ({ slug: slug.value }))

  const { loading, error, result } = useReviewsProductSurveyResponsesViewFacetQuery(variables, { clientId: 'reviews' })

  const outdatedCount = computed(
    () => result.value?.manage?.surveyResponses?.viewFacet?.find((facet) => facet.key === SurveyResponsesViewEnum.Outdated)?.docCount ?? 0,
  )

  return { outdatedCount, loading, error }
}
